import React from 'react';
import SKU from './SKU';
import { getXrplNetworkName } from '../common/Constants';
import { REACT_APP_NETWORK_ID } from '../../config';

const TestnetValueTag = () => {
  return (
    <SKU variant="gold">
        {getXrplNetworkName(REACT_APP_NETWORK_ID)} FUNDS - ZERO VALUE
    </SKU>
  )
}

export default TestnetValueTag;